import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const funnelApiService = createApi({
  reducerPath: "funnelApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getFunnelWithFilter: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `funnel/get-with-date${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetFunnelWithFilterQuery } = funnelApiService;
